var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DatePicker',{staticStyle:{"width":"100%"},attrs:{"value":_vm.currentValue,"transfer":"","type":_vm.type},on:{"on-change":_vm.changeHandler},nativeOn:{"input":function($event){return _vm.inputHandler($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }